import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientSidePermissionSetContainerComponent } from './client-side-permission-container.component';
import { ClientSidePermissionListingComponent } from './client-side-permission-listing/client-side-permission-listing.component';
import { ClientSidePermissionAddComponent } from './client-side-permissiont-add/client-side-permission-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SharedUtilitiesModule } from '../../../../utilities/shared-utilities.module';
import { ClientSidePermissionEditComponent } from './client-side-permissiont-edit/client-side-permission-edit.component';

@NgModule({
  declarations: [
    ClientSidePermissionSetContainerComponent,
    ClientSidePermissionListingComponent,
    ClientSidePermissionAddComponent,
    ClientSidePermissionEditComponent
  ],
  imports: [
    CommonModule,
    SharedUtilitiesModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule
  ]
})
export class ClientSidePermissionSetModule { }
